import * as ActionTypes from './types.action';

export const setEventManually = (error, data) => ({
  type: ActionTypes[error],
  data,
});
